<template lang="pug">
  .contacts(v-if="contacts")
    .contacts__border.contacts__border--top
    .contacts__border.contacts__border--right
    .contacts__border.contacts__border--bottom
    .contacts__border.contacts__border--left
    .contacts__corner.contacts__corner--tl
    .contacts__corner.contacts__corner--tr
    .contacts__corner.contacts__corner--bl
    .contacts__corner.contacts__corner--br
    .contacts__decor-top
    .contacts__decor-bottom
    .contacts__title(v-if="h1") {{h1}}
    .contacts__content
      .contacts__top
        .contacts__left
          .contacts__map-wr
            .contacts__map.js-contacts-map
              .contacts__map-preloader
        .contacts__right
          .contacts__item(v-if="contacts.contacts.address")
            SvgIcon(name="address" width="22" height="24" class="contacts__item-ico")
            .contacts__item-text(v-html="contacts.contacts.address")
          .contacts__item(v-if="contacts.contacts.time")
            SvgIcon(name="time" width="22" height="22" class="contacts__item-ico")
            .contacts__item-text {{contacts.contacts.time}}
          .contacts__item(v-if="contacts.contacts.phone")
            SvgIcon(name="phone" width="22" height="22" class="contacts__item-ico")
            .contacts__item-phones
              a.contacts__item-link(v-for="item in contacts.contacts.phone", :href="item.link", :key="item.id") {{item.text}}
          .contacts__socials(v-if="contacts.contacts.socials")
            .contacts__socials-title Мы в соцсетях:
            .contacts__socials-items
              a.contacts__socials-item.contacts__socials-item--instagram(v-if="contacts.contacts.socials.instagram", :href="contacts.contacts.socials.instagram", target="_blank")
                SvgIcon(name="instagram" width="25" height="25" class="contacts__socials-item-ico")
              a.contacts__socials-item.contacts__socials-item--vk(v-if="contacts.contacts.socials.vk", :href="contacts.contacts.socials.vk", target="_blank")
                SvgIcon(name="vk" width="25" height="25" class="contacts__socials-item-ico")
              a.contacts__socials-item.contacts__socials-item--telegram(v-if="contacts.contacts.socials.telegram", :href="contacts.contacts.socials.telegram", target="_blank")
                SvgIcon(name="telegram" width="25" height="25" class="contacts__socials-item-ico")
              a.contacts__socials-item.contacts__socials-item--facebook(v-if="contacts.contacts.socials.facebook", :href="contacts.contacts.socials.facebook", target="_blank")
                SvgIcon(name="facebook" width="25" height="25" class="contacts__socials-item-ico")

      form.contacts__form(v-on:submit.prevent="submit")
        .contacts__form-left
          .contacts__form-row
            label.contacts__form-label ФИО*
            input.contacts__form-input(v-model="name" type="text" name="name" autocomplete="off" required)
          .contacts__form-col
            .contacts__form-row
              label.contacts__form-label Email*
              input.contacts__form-input(v-model="email" type="email" name="email" autocomplete="off" required)
            .contacts__form-row
              label.contacts__form-label Телефон
              input.contacts__form-input(v-model="phone" v-mask="'+7(###)-###-##-##'" type="text" autocomplete="off" name="phone")
          .contacts__form-row
            label.contacts__form-label Текст сообщения*
            textarea.contacts__form-textarea(v-model="message" name="message" autocomplete="off" required)
          button.contacts__form-clear(type="reset") Очистить
        .contacts__form-right
          .contacts__agreement
            | Нажимая кнопку «Отправить», Вы даёте согласие на обработку
            router-link(to="/politika-konfidencialnosti" target="_blank").contacts__agreement-link персональных данных
          button.contacts__send-btn(type="submit")
            | Отправить
        .contacts__form-message Сообщение отправлено!

</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/contacts/contacts.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {YaHelpersVue} from '@/mixins/YaHelpersVue';
import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';
import {FormHelpersVue} from '@/mixins/FormHelpersVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

export default {
  name: 'Contacts',

  mixins: [AjaxHelpersVue, YaHelpersVue, PopupHelpersVue, FormHelpersVue],

  data() {
    return {
      contacts: null,
      isMapInit: false,
      ps: null,

      // Поля формы
      name: '',
      email: '',
      phone: '',
      message: ''
    }
  },

  components: {
    SvgIcon
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadContactsPage', params => {
      this.request(params.url);
    });
  },

  methods: {
    request(url) {
      this.req('ContactsPage:getContactsPage', {url}, res => {
        if(this.checkProperty(res.content)) {
          this.contacts = res.content;
        }

        if(this.checkProperty(res.content.initMapConfig)) {
          this.$nextTick(() => {
            this.initScroll();
            if(!this.isMapInit) {
              this.initMapLocal('.js-contacts-map', res.content.initMapConfig);
            }
          })
        }
      }, 'contacts');
    },

    initMapLocal(block, initMapConfig) {
      this
          .initMap(block, initMapConfig)
          // Когда карта загружена
          .then(() => {
            // Добавляем на карту placemarks
            this.addAllPlacemarks(initMapConfig.coords).then(() => {

              setTimeout(() => {
                $('.contacts__map-preloader').addClass('contacts__map-preloader--hide');
              }, 750);
            });

            this.isMapInit = true;
          });
    },

    submit() {
      let data = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        message: this.message
      };

      this.submitForm('ContactsPage:sendForm', data, res => {
        this.name  = '';
        this.email = '';
        this.phone = '';
        this.message = '';

        this.$nextTick(() => {
          $('.contacts__form-left').addClass('contacts__form-left--hide');
          $('.contacts__form-right').addClass('contacts__form-right--hide');
          $('.contacts__form-message').addClass('contacts__form-message--show');
        })

        //console.log(res);
      });
    },

    initScroll() {
      if(this.ps === null) {
        this.ps = new PerfectScrollbar('.contacts__content', {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
      }
      else {
        this.ps.update();
      }
    },
  }
}
</script>
